<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">

                <p class="justify-content-center font-weight-700">
                    Terms and Conditions
                </p>
                <div class="row justify-content-center">

                    <br>
                    <p>REGISTERING TO USE THE MEMBER PORTAL</p>
                    <p> By registering to use this portal and logging on with your password and email, you agree to
                        provide us with true, accurate, current, and complete information about yourself as requested
                        and to maintain and promptly update your information to keep it accurate, current, and complete.
                        Rajput Association of North America (RANA) reserves the right to terminate your access to our
                        site and/or to the portal at any time and for any reason.
                    </p>

                    <p> PORTAL ACCOUNTS, PASSWORD, AND SECURITY</p>
                    <p> You may open a portal account online using your email/member identification number. Once you
                        establish an account you will be asked to create a password that you will need to access your
                        information. Associate Member will need their Member Identification Number also. You are
                        responsible for maintaining the confidentiality of the password and are fully responsible for
                        all activities that occur under your password. You agree to immediately notify Rajput
                        Association of North America (RANA) of any unauthorized use of your password or other breach of
                        security and to exit from your account at the end of each session. Rajput Association of North
                        America (RANA) cannot and will not be liable for any losses or damages arising from your failure
                        to comply with this section. Except where expressly authorized by law, you certify that you are
                        not using another person’s password or user identification to gain access to this portal/site.
                        You agree not to falsely state or otherwise misrepresent your affiliation with a person or
                        entity to obtain access to this portal. You also agree not to copy or disseminate,
                        electronically or otherwise, personal information found on this portal.</p>
                </div>
            </div>
        </div>
    </div>
</div>
